<template>
    <select class="form-control"
            v-on:change="$emit('updateInput', content.name, $event.target.value)">
        <option v-for="option in content.options" :value="option.value" :key="option">{{option.text}}</option>
    </select>
</template>

<script>
    export default {
        name: "Select",
        props: {
            content: Object
        },
        data() {
            return {
                value: ''
            }
        },
        emits:
            ['updateInput']
    }
</script>

<style>

</style>